// extracted by mini-css-extract-plugin
export default {"activeNav":"Settings_activeNav__QIG5K","nav":"Settings_nav__VdDxh"};